import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function SuppliersGiftSection() {
  return <section className="py-12 md:py-20 px-4 overflow-hidden bg-[#2F0240] pt-[0px] pb-[0px]" data-id="element-373">
      <div className="max-w-5xl mx-auto text-center" data-id="element-374">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="md:text-4xl font-black text-white uppercase tracking-tight text-[30px] mt-[25px] mb-[25px]" data-id="element-375">
          Incluye <span className="text-[#FC9DFF]" data-id="element-376">lista de proveedores</span> e
          importadores de toda Latinoamérica
        </motion.h2>

        <div className="relative inline-block" data-id="element-377">
          {/* Purple Neon Glow Background */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[120%] h-[120%] bg-[#9C16A3]/30 blur-[80px] rounded-full animate-pulse" data-id="element-378"></div>

          <motion.div initial={{
          scale: 0.9,
          opacity: 0
        }} whileInView={{
          scale: 1,
          opacity: 1
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} viewport={{
          once: true
        }} className="relative z-10" data-id="element-379">
            <img src="https://cdn.magicpatterns.com/uploads/63xcvvztmgdPSSqB8Ychwy/Diseno_sin_titulo_(2).png" alt="Lista de Proveedores Luxury Browes" className="w-full max-w-3xl mx-auto rounded-3xl shadow-[0_0_50px_rgba(156,22,163,0.4)] border border-[#FC9DFF]/20 mt-[-10px] mb-[-10px]" loading="lazy" data-id="element-380" />
          </motion.div>
        </div>

        <div className="mt-12 flex flex-wrap justify-center gap-4 md:gap-8" data-id="element-381">
          {['Proveedores Confiables', 'Productos de Calidad', 'Ahorra Tiempo y Dinero'].map((benefit, i) => <div key={i} className="flex items-center gap-2 text-[#FC9DFF] font-bold uppercase text-sm md:text-base mt-[0px] mb-[0px]" data-id="element-382">
              <span className="w-2 h-2 bg-[#FC9DFF] rounded-full shadow-[0_0_8px_#FC9DFF]" data-id="element-383"></span>
              {benefit}
            </div>)}
        </div>
      </div>
    </section>;
}